import {EventEmitter, Injectable, Output} from '@angular/core';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {BackendServiceResponse} from '../../model/backend-service-response';
import {Dictionary} from '../../model/dictionary';
import {MasbitHttpService} from '../../common/http/masbit-http.service';
import {Report} from "../../model/report";

@Injectable()
export class UserReportsService {

  static readonly DICT_CONTENT_TYPE_GET_BY_DICTID = environment.apiUrl.concat(environment.dictContentTypeFindOneByDictIdUrl);
  static readonly REPORT_GET_FILE_FORMATS_SERVICE_URL = environment.apiUrl.concat(environment.reportGetFileFormatsServiceUrl);
  static readonly REPORT_MARK_AS_SHOWN_ON_USER_LIST_SERVICE_URL = environment.apiUrl.concat(environment.reportMarkAsShownOnUserList);

  constructor(private httpClient: MasbitHttpService) { }

  @Output() selfTutorInProgress = new EventEmitter<boolean>();
  @Output() refreshOnCloseSelfTutor = new EventEmitter<boolean>();

  getContentTypeById(contentTypeDictId : number) : Observable<Dictionary> {
    return this.httpClient.post<Dictionary>(UserReportsService.DICT_CONTENT_TYPE_GET_BY_DICTID, {dictId : contentTypeDictId});
  }

  getFileFormats() : Observable<BackendServiceResponse<number, Array<string>>> {
    return this.httpClient.get<BackendServiceResponse<number, Array<string>>>(UserReportsService.REPORT_GET_FILE_FORMATS_SERVICE_URL);
  }

  markAsShownOnUserList(reportId : Array<number>, userId : number) : Observable<BackendServiceResponse<number, string>> {
    return this.httpClient.post<BackendServiceResponse<number, string>>(
      UserReportsService.REPORT_MARK_AS_SHOWN_ON_USER_LIST_SERVICE_URL,
        {userId: userId, reportId : reportId})
  }

  setSelfTutorInProgress(status : boolean) {
    this.selfTutorInProgress.emit(status);
  }

  setRefresh(refresh : boolean) {
    this.refreshOnCloseSelfTutor.emit(refresh);
  }
}
